import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "disabledReason", "dropdownFooter", "itemComponent", "onChange", "options", "value", "clearable"];
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DataColumnsHintFooter from '../../shared-components/dropdown/DataColumnsHintFooter';
import BaseSelectComponent from '../../shared-components/BaseSelectComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const BreakdownEditorSelect = _ref => {
  let {
      disabled = false,
      disabledReason,
      dropdownFooter = /*#__PURE__*/_jsx(DataColumnsHintFooter, {}),
      itemComponent,
      onChange,
      options,
      value,
      clearable
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(InputGroup, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.breakdown-editor-dropdown.config.label"
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.breakdown-editor-dropdown.config.tooltip"
    }),
    use: "itemRight",
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsx(BaseSelectComponent, Object.assign({}, selectProps, {
        clearable: clearable,
        itemComponent: itemComponent,
        dropdownFooter: dropdownFooter,
        disabled: disabled,
        tooltipText: disabledReason,
        options: options,
        value: value,
        onChange: onChange,
        useDefaultValueComponent: false,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "report-customization-components.customization-components.breakdown-editor-dropdown.config.placeholder"
        })
      }))
    })
  });
};
export default BreakdownEditorSelect;